<div class="compact-controls-container">
    <div class="background-img" data-testid="player_compact_background" [transcodeImage]="itemPosterUrl()"></div>
    <!-- Cast toggle (top-right) -->
    @if(isCasting()){
    <rounded-icon-button class="cast-toggle" [size]="'large'" [transparentBackground]="true"
        [imgSrc]="skinning.getImage('icon_cast_connected')" (onClick)="toggleCast()"></rounded-icon-button>
    }
    <!-- Info Section -->
    <div class="info-section">
        <div class="logo-container">
            <!-- Single-axis transcode: with both axes the transcoder CROPS to 120x80,
                 chopping square station logos. Height-only keeps the aspect ratio. -->
            <img [transcodeImage]="itemLogo()" transcodeAxis="height" alt="Logo" class="item-logo">
        </div>
        <div class="track-info">
            <h2 class="title" data-testid="player_compact_title">{{itemTitle()}}</h2>
            <p class="subtitle"></p>
        </div>
    </div>

    <!-- Progress Section -->
    <div class="progress-section">
        @if(isCurrentItemLive()){
        <div class="timeline-container">
            <p-slider class="timeline" [ngModel]="liveProgress()" [min]="liveSeekMin()" [max]="liveTimeEnd()"
                (mousedown)="$event.stopPropagation()" (touchstart)="$event.stopPropagation()"
                (pointerdown)="$event.stopPropagation()" (mousemove)="onSeekHover($event)"
                (mouseleave)="onSeekClearHover()" (ngModelChange)="onSeekLive($event)"
                [disabled]="!liveTimeStart() || !liveTimeEnd() || !isSeekEnabled()"></p-slider>
        </div>
        <div class="flex justify-between">
            <div class="time">
                <span data-testid="player_compact_time-start">{{ liveTimeStart() | date:'HH:mm:ss' }}</span>
            </div>

            <div class="live-indicator flex" (click)="onLive()" [ngClass]="{ 'cursor-pointer': !(isLive()) }">
                <rounded-icon-button class="control w-auto relative" [ngClass]="{ 'disabled': isLive() }"
                    [transparentBackground]="true" [size]="'large'" [imgSrc]="skinning.getImage('icon_live')"
                    [imgColor]="skinning.getRootVariableValue(isLive() ? '--exclamation' : '--text_secondary')"></rounded-icon-button>
                <span class="flex items-center justify-center" [ngClass]="{ 'disabled': isLive() }">{{
                    (isLive() ? 'player.live' : 'player.controls.return_to_live') | transloco }}</span>
            </div>

            <div class="time">
                <span data-testid="player_compact_time-end">{{ liveTimeEnd() | date:'HH:mm:ss'}}</span>
            </div>
        </div>
        }@else {
        <div class="timeline-container">
            <p-slider class="timeline" [ngModel]="progress()" [max]="duration()" (mousedown)="$event.stopPropagation()"
                (touchstart)="$event.stopPropagation()" (pointerdown)="$event.stopPropagation()"
                (mousemove)="onSeekHover($event)" (mouseleave)="onSeekClearHover()"
                (ngModelChange)="onSeek($event)"></p-slider>
        </div>
        <div class="flex justify-between">
            <div class="time">
                <span>{{ (progress() * 1000 ) | date:'HH:mm:ss':'UTC' }}</span>
            </div>
            <div class="time">
                <span>{{ (duration() * 1000 ) | date:'HH:mm:ss':'UTC'}}</span>
            </div>
        </div>
        }
    </div>

    <!-- Controls Section -->
    <div class="controls flex justify-between items-center">
        <!-- Options menu: -->

        <rounded-icon-button class="control relative" [size]="'large'" [transparentBackground]="true"
            [imgSrc]="skinning.getImage('icon_more_round')" (onClick)="openDetails()"
            [disabled]="isControlDisabled()"></rounded-icon-button>
        <rounded-icon-button class="control relative" [size]="'large'" [transparentBackground]="true"
            [imgSrc]="skinning.getImage('icon_start_over')" (onClick)="onReplay()"
            data-testid="player_compact_start-over"
            [disabled]="isControlDisabled() || !isSeekEnabled() || !isRestartEnabled()"></rounded-icon-button>
        <rounded-icon-button class="control relative" [size]="'large'" [transparentBackground]="true"
            [imgSrc]="skinning.getImage('icon_play_backward')" (onClick)="setSeek(-10)"
            data-testid="player_compact_seek-backward"
            [disabled]="isControlDisabled() || !isSeekEnabled()"></rounded-icon-button>
        <rounded-icon-button class="control relative" [size]="'large'" [transparentBackground]="true"
            [imgSrc]="skinning.getImage(isPlaying()?'icon_pause':'icon_play')"
            [attr.data-testid]="isPlaying() ? 'player_compact_pause' : 'player_compact_play'"
            (onClick)="isPlaying()?onPause():onPlay()" [disabled]="isPlaying() && !isPauseEnabled()"></rounded-icon-button>
        <rounded-icon-button class="control relative" [size]="'large'" [transparentBackground]="true"
            [imgSrc]="skinning.getImage('icon_play_forward')" (onClick)="setSeek(10)"
            data-testid="player_compact_seek-forward"
            [disabled]="isControlDisabled() || !isSeekEnabled()"></rounded-icon-button>
        <rounded-icon-button class="control relative" [size]="'large'" [transparentBackground]="true"
            [imgSrc]="skinning.getImage('icon_stop')" (onClick)="onClose()"></rounded-icon-button>

        <div class="volume-container">
            <div class="volume-component">
                <div class="slider-wrapper">
                    <p-slider class="volume" [ngModel]="volume()" [max]="100" (ngModelChange)="onVolume($event)"
                        (mousedown)="$event.stopPropagation()" (touchstart)="$event.stopPropagation()"
                        (pointerdown)="$event.stopPropagation()" orientation="vertical"></p-slider>
                </div>
            </div>
            <rounded-icon-button class="control relative" [size]="'large'" [transparentBackground]="true"
                [imgSrc]="skinning.getImage(isMuted()?'icon_sound_off':'icon_sound_on')"
                (onClick)="toggleMute()"></rounded-icon-button>
        </div>

    </div>
</div>